"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TelerikReportViewer = void 0;
require("../dependencies/initExtDeps");
var _react = _interopRequireDefault(require("react"));
var _telerikReportViewer = require("../dependencies/telerikReportViewer.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var TelerikReportViewer = /*#__PURE__*/function (_React$Component) {
  _inherits(TelerikReportViewer, _React$Component);
  var _super = _createSuper(TelerikReportViewer);
  function TelerikReportViewer() {
    var _this;
    _classCallCheck(this, TelerikReportViewer);
    _this = _super.call(this);
    _this.state = {
      reportViewerID: ''
    };
    return _this;
  }
  _createClass(TelerikReportViewer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        reportViewerID: this.props.id || "reportViewer1"
      });
      var keepClientAlive = this.props.keepClientAlive === undefined ? true : this.props.keepClientAlive;
      this.viewerObject = new _telerikReportViewer.ReportViewer(this.el, {
        id: this.state.reportViewerID,
        serviceUrl: this.props.serviceUrl,
        reportServer: this.props.reportServer,
        trvTemplateUrl: this.props.templateUrl,
        initialPageAreaImageUrl: this.props.initialPageAreaImageUrl,
        reportSource: this.props.reportSource,
        sendEmail: this.props.sendEmail,
        scale: this.props.scale,
        scaleMode: this.props.scaleMode,
        viewMode: this.props.viewMode,
        pageMode: this.props.pageMode,
        parameters: this.props.parameters,
        persistSession: this.props.persistSession,
        parameterEditors: this.props.parameterEditors,
        authenticationToken: this.props.authenticationToken,
        ready: this.props.ready,
        printMode: this.props.printMode,
        selector: this.props.selector,
        disabledButtonClass: this.props.disabledButtonClass,
        checkedButtonClass: this.props.checkedButtonClass,
        exportBegin: this.props.exportBegin,
        exportEnd: this.props.exportEnd,
        printBegin: this.props.printBegin,
        printEnd: this.props.printEnd,
        renderingBegin: this.props.renderingBegin,
        renderingEnd: this.props.renderingEnd,
        sendEmailBegin: this.props.sendEmailBegin,
        sendEmailEnd: this.props.sendEmailEnd,
        updateUi: this.props.updateUi,
        pageReady: this.props.pageReady,
        error: this.props.error,
        interactiveActionExecuting: this.props.interactiveActionExecuting,
        interactiveActionEnter: this.props.interactiveActionEnter,
        interactiveActionLeave: this.props.interactiveActionLeave,
        viewerToolTipOpening: this.props.viewerToolTipOpening,
        enableAccessibility: this.props.enableAccessibility,
        searchMetadataOnDemand: this.props.searchMetadataOnDemand,
        parametersAreaVisible: this.props.parametersAreaVisible,
        documentMapVisible: this.props.documentMapVisible,
        documentMapAreaPosition: this.props.documentMapAreaPosition,
        parametersAreaPosition: this.props.parametersAreaPosition,
        keepClientAlive: keepClientAlive
      });
      this.commands = this.viewerObject.commands;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.dispose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react.default.createElement("div", {
        id: this.state.reportViewerID,
        style: _objectSpread({}, this.props.viewerContainerStyle),
        ref: function ref(el) {
          return _this2.el = el;
        }
      });
    }
  }, {
    key: "refreshReport",
    value: function refreshReport() {
      return this.viewerObject.refreshReport();
    }
  }, {
    key: "getReportSource",
    value: function getReportSource() {
      return this.viewerObject.reportSource();
    }
  }, {
    key: "setReportSource",
    value: function setReportSource(rs) {
      return this.viewerObject.reportSource(rs);
    }
  }, {
    key: "getViewMode",
    value: function getViewMode() {
      return this.viewerObject.viewMode();
    }
  }, {
    key: "setViewMode",
    value: function setViewMode(vm) {
      return this.viewerObject.viewMode(vm);
    }
  }, {
    key: "getScale",
    value: function getScale() {
      return this.viewerObject.scale();
    }
  }, {
    key: "setScale",
    value: function setScale(scale) {
      return this.viewerObject.scale(scale);
    }
  }, {
    key: "pageCount",
    value: function pageCount() {
      return this.viewerObject.pageCount();
    }
  }, {
    key: "currentPage",
    value: function currentPage() {
      return this.viewerObject.currentPage();
    }
  }, {
    key: "setAuthenticationToken",
    value: function setAuthenticationToken(token) {
      return this.viewerObject.authenticationToken(token);
    }
  }, {
    key: "getAccessibilityKeyMap",
    value: function getAccessibilityKeyMap() {
      return this.viewerObject.accessibilityKeyMap();
    }
  }, {
    key: "setAccessibilityKeyMap",
    value: function setAccessibilityKeyMap(keyMap) {
      return this.viewerObject.accessibilityKeyMap(keyMap);
    }
  }, {
    key: "bind",
    value: function bind(eventName, eventHandler) {
      this.viewerObject.bind(eventName, eventHandler);
    }
  }, {
    key: "unbind",
    value: function unbind(eventName, eventHandler) {
      this.viewerObject.unbind(eventName, eventHandler);
    }
  }, {
    key: "unbindAll",
    value: function unbindAll(eventName) {
      this.viewerObject.unbind(eventName);
    }
  }, {
    key: "getPageMode",
    value: function getPageMode() {
      return this.viewerObject.pageMode();
    }
  }, {
    key: "setPageMode",
    value: function setPageMode(psm) {
      return this.viewerObject.pageMode(psm);
    }
  }, {
    key: "clearReportSource",
    value: function clearReportSource() {
      return this.viewerObject.clearReportSource();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      return this.viewerObject.dispose();
    }
  }]);
  return TelerikReportViewer;
}(_react.default.Component);
exports.TelerikReportViewer = TelerikReportViewer;
var _default = TelerikReportViewer;
exports.default = _default;